import {create} from 'zustand';

import {OpenOptionsDrawerStore} from './types';

export const useOpenOptionsDrawerStore = create<OpenOptionsDrawerStore>(set => ({
	isOptionsDrawerOpen: false,
	optionsDrawerItems: [],
	optionsDrawerTitle: '',
	openOptionsDrawer: (title, items) =>
		set({isOptionsDrawerOpen: true, optionsDrawerTitle: title, optionsDrawerItems: items}),
	closeOptionsDrawer: () => set({isOptionsDrawerOpen: false}),
	reopenOptionsDrawer: () => set({isOptionsDrawerOpen: true}),
}));
